import { PeopleBadgeList } from '@/routes/_layout/scheduling/student-groups/-components/people-badge-list';
import { getSessionSubstitutionRequestSummary } from '@airreading/common';
import {
  AdminSession,
  SubstitutionRequestStatus,
  VideoConferenceType,
  SubstitutionRequestOrigin,
} from '@airreading/common/data';

interface OriginalTeacherDisplayProps {
  session: AdminSession;
  testId?: string;
}

export function isOriginalTeacherPendingSubstitute(session: AdminSession): boolean {
  const { mostRecentRequest } = getSessionSubstitutionRequestSummary(session);
  return (
    session.videoConferenceType === VideoConferenceType.zoom &&
    mostRecentRequest?.status === SubstitutionRequestStatus.pending &&
    mostRecentRequest.origin === SubstitutionRequestOrigin.automatic_conflict
  );
}

export const OriginalTeacherDisplay = ({ session, testId }: OriginalTeacherDisplayProps) => {
  const { coach } = session;

  if (isOriginalTeacherPendingSubstitute(session)) {
    return <span data-testid={testId}>Pending substitute teacher</span>;
  }
  if (!coach) {
    return null;
  }
  return <PeopleBadgeList people={[coach]} testId={testId} />;
};
